import { render, staticRenderFns } from "./OctSelect.vue?vue&type=template&id=b6b39482&scoped=true&"
import script from "./OctSelect.vue?vue&type=script&lang=js&"
export * from "./OctSelect.vue?vue&type=script&lang=js&"
import style0 from "./OctSelect.vue?vue&type=style&index=0&id=b6b39482&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b39482",
  null
  
)

export default component.exports